<template>
  <div id="app__ernest" :class="{ 'app__ernest__user' : !user.isStaff || !user.staffStatus }">
    <header class="app__header__ernest">
      <div>
        <u-icon>{{ titleSection[$route.name].icon }}</u-icon>
      </div>
      <div>
        <div><span>{{ titleSection[$route.name].title }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <router-view/>

    <div class="app__ernest__credits" v-if="!user.isStaff || !user.staffStatus">
      <header class="app__header__ernest">
        <div>
          <v-icon>mdi-copyright</v-icon>
        </div>
        <div>
          <div><span>{{ $t('app.ernestHeader.credits') }}</span></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div></div>
      </header>

      <section class="app__section__ernest" v-html="staticText"></section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Template',
  data () {
    return {
      titleSection: {
        home_user: {
          title: this.$t('app.ernestHeader.questionnaireList'),
          icon: 'Ù'
        },
        userQuestionnairePass: {
          title: this.$t('app.ernestHeader.questionnaireDetail'),
          icon: 'Ù'
        },
        user_results: {
          title: 'Mes résultats',
          icon: '¿'
        }
      },
      staticText: ''
    }
  },
  computed: {
    ...mapGetters('User', [
      'user'
    ])
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/credits/'
    }).then(response => {
      this.staticText = response.data.text
    })

    await this.loadUser()
  },
  methods: {
    ...mapActions('User', [
      'loadUser'
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/styleAppErnest";

  .app__ernest__credits {
    .app__header__ernest {
      margin-top: 30px;
    }
  }
</style>
